import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { api } from '@/services/api';

export const PART_FINDER_BATCHES_QUERY_KEY = 'partFinderBatches.list';
export const PART_FINDER_BATCH_QUERY_KEY = 'partFinderBatch';

export const queryKey = ({
  tenantId,
  page,
  perPage,
}: {
  tenantId: string;
  page?: string | number;
  perPage?: string | number;
}) => [
  PART_FINDER_BATCHES_QUERY_KEY,
  {
    tenantId,
    page: +(page ?? 1),
    perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
  },
];

export const queryFunction =
  ({ tenantId, page, perPage }: { tenantId: string; page?: string | number; perPage?: string | number }) =>
  () => {
    return api.tenants.listPartFinderBatches(tenantId, +(page ?? 1), +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE));
  };
